import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { MarketProvider } from "./context/MarketContext";
import { StockProvider } from "./context/StockContext";
import { RecommendationProvider } from "./context/RecommendationContext";
import { NewsProvider } from "./context/NewsContext";
import { ResultProvider } from "./context/ResultContext";
import { MoreStockProvider } from "./context/MoreStockContext";
import { PcrProvider } from "./context/PcrContext";

import { StockNameProvider } from "./context/StockNameContext";
import { StockDailyProvider } from "./context/StockDailyContext";
import { StockMarketCapProvider } from "./context/StockMarketCapContext";
import { OptionProvider } from "./context/OptionContext";
import { SecurityMasterProvider } from "./context/SecurityMasterContext";
import { MarketDhanProvider } from "./context/MarketDhanContext";
import { MarketIndicatorProvider } from "./context/MarketIndicatorContext";
import { AIChatProvider } from "./context/AIChatContext";
import { IndicatorProvider } from "./context/IndicatorContext";
import { PredictionProvider } from "./context/PredictionContext";
import { RegisterProvider } from "./context/RegisterContext";
import { VerificationProvider } from "./context/VerificationContext";
import { AuthNewProvider } from "./context/AuthNewContext";
import { PasswordAuthProvider } from "./context/PasswordAuthContext";
import { ExportProvider } from "./context/ExportContext";
import { CaptchaProvider } from "./context/CaptchaContext";
import { PdfProvider } from "./context/PdfContext";
import { WatchlistProvider } from "./context/WatchlistContext";
import { UserProvider } from "./context/UserContext";
import { AdminContext, AdminProvider } from "./context/AdminContext";
import { FeedbackProvider } from "./context/FeedbackContext";
import { NotificationProvider } from "./context/NotificationContext";
import { ChartIndicatorProvider } from "./context/ChartIndicatorContext";
import { FavStockProvider } from "./context/FavStockContext";
import { SearchStockProvider } from "./context/SearchStockContext";
import { TechnicalSnapshotProvider } from "./context/TechnicalSnapshotContext";
import { MarketSnapshotProvider } from "./context/MarketSnapshotContext";
import { StockSnapshotProvider } from "./context/StockSnapshotContext";
import { IndexSnapshotProvider } from "./context/IndexContext";
import { IndexSymbolProvider } from "./context/IndexSymbolContext";
import { EmaStrategyProvider } from "./context/EmaStrategyContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <MarketProvider>
        <StockProvider>
          <RecommendationProvider>
            <ResultProvider>
              <MoreStockProvider>
                <NewsProvider>
                  <PcrProvider>
                    {/* <StockDetailProvider> */}
                    <StockNameProvider>
                      <StockDailyProvider>
                        <StockMarketCapProvider>
                          <OptionProvider>
                            <SecurityMasterProvider>
                              <MarketDhanProvider>
                                <MarketIndicatorProvider>
                                  <AIChatProvider>
                                    <IndicatorProvider>
                                      <PredictionProvider>
                                        <RegisterProvider>
                                          <VerificationProvider>
                                            <AuthNewProvider>
                                              <PasswordAuthProvider>
                                                <ExportProvider>
                                                  <CaptchaProvider>
                                                    <PdfProvider>
                                                      <WatchlistProvider>
                                                        <UserProvider>
                                                          <AdminProvider>
                                                            <FeedbackProvider>
                                                              <NotificationProvider>
                                                                <ChartIndicatorProvider>
                                                                  <FavStockProvider>
                                                                    <SearchStockProvider>
                                                                      <TechnicalSnapshotProvider>
                                                                        <MarketSnapshotProvider>
                                                                          <StockSnapshotProvider>
                                                                            <IndexSnapshotProvider>
                                                                              <IndexSymbolProvider>
                                                                                <EmaStrategyProvider>
                                                                                  <App />
                                                                                </EmaStrategyProvider>
                                                                              </IndexSymbolProvider>
                                                                            </IndexSnapshotProvider>
                                                                          </StockSnapshotProvider>
                                                                        </MarketSnapshotProvider>
                                                                      </TechnicalSnapshotProvider>
                                                                    </SearchStockProvider>
                                                                  </FavStockProvider>
                                                                </ChartIndicatorProvider>
                                                              </NotificationProvider>
                                                            </FeedbackProvider>
                                                          </AdminProvider>
                                                        </UserProvider>
                                                      </WatchlistProvider>
                                                    </PdfProvider>
                                                  </CaptchaProvider>
                                                </ExportProvider>
                                              </PasswordAuthProvider>
                                            </AuthNewProvider>
                                          </VerificationProvider>
                                        </RegisterProvider>
                                      </PredictionProvider>
                                    </IndicatorProvider>
                                  </AIChatProvider>
                                </MarketIndicatorProvider>
                              </MarketDhanProvider>
                            </SecurityMasterProvider>
                          </OptionProvider>
                        </StockMarketCapProvider>
                      </StockDailyProvider>
                    </StockNameProvider>

                    {/* </StockDetailProvider> */}
                  </PcrProvider>
                </NewsProvider>
              </MoreStockProvider>
            </ResultProvider>
          </RecommendationProvider>
        </StockProvider>
      </MarketProvider>
    </AuthProvider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
